<div class="form-field-wrapper">
  <div class="app-form-field">
    @let control = getControl();
    <mat-form-field appearance="outline">
      <mat-label>{{ label() }}</mat-label>
      <mat-select [formControl]="control" (selectionChange)="handleSelectionChange($event)">
        @for (option of options(); track option) {
          <mat-option [value]="option.value" [disabled]="option.disabled ?? false">{{ option.label | transloco }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-tooltip [tooltip]="hint()"></app-tooltip>
  </div>
  <app-form-error [control]="control"></app-form-error>
</div>
